export const getHostNameFromURL = (url: string) => {
  return new URL(url).hostname;
};
